import {Grid, Typography} from '@mui/material';
import React from 'react'
import Image from "mui-image";
import SocialBtn from "./SocialBtn";

function SocialBanner(props) {
    console.log(props)
    return (
        <>
            <Grid container>
                <Image src="https://cdn-ltm.betflag.it/site/img/bflive/banner-home-bflive.jpg" alt="Description"
                       fit="cover"
                       loading="lazy"></Image>
            </Grid>
            <Grid container sx={{backgroundColor: '#002742', padding: {xs: 1.5, sm: 3}}}>
                <Grid item xs={10} sm={11} md={9} flexDirection="column" marginTop="auto" marginBottom="auto">
                    <Typography
                        variant="h4"
                        sx={{
                            color: 'white',
                            margin: 0,
                            fontWeight: 'bold',
                            fontSize: {xs: '1.5rem', sm: '1.4rem', md: '2.15rem'}
                        }}
                    > Segui BetflagLive
                        anche sui social!</Typography>
                    <Typography variant="h6"
                                sx={{color: 'white', margin: 0, display: {xs: 'none', sm: 'block'}}}> Scopri contenuti
                        inediti sportivi, news e
                        storie ogni giorno sui nostri canali </Typography>
                </Grid>
                <Grid item xs={2} sm={1} md={3} lg={3}>
                    {props.socialButtons.map((social, index) => (
                        <Grid item xs={8} sm={6} md={12} key={social.title + index} marginLeft='auto'>
                            <SocialBtn platform={social.title} username={'BetflagLive'}></SocialBtn>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
            <Grid container my={3}></Grid>
        </>
    )
}

export default SocialBanner